import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import ReactToPrint from "react-to-print";
import { PrinterOutlined } from "@ant-design/icons";
import moment from "moment";
import Barcode from "react-barcode";
import { getBusinessProfile } from "../../../actions/settings";
import {
  Button,
  Col,
  Row,
  Drawer,
  Skeleton,
} from "antd";

const EcommerceOrderPrint = ({
  invoice,
  items,
  services,
  branch,
  businessprofile,
  getBusinessProfile,
}) => {
  var formatter = new Intl.NumberFormat("en-IN");
  const componentRef = useRef();
  const [visible, setVisible] = useState(false);
  const [loading, setloading] = useState(false);
  const count = useRef(0);
  const serialcount = useRef(0);
  console.log(items)

  useEffect(() => {
    if (visible && !businessprofile) {
      getBusinessProfile();
    }
  }, [visible, businessprofile, getBusinessProfile]);

  const showDrawer = () => {
    setVisible(true);
  };

  const onClose = () => {
    setVisible(false);
  };

  const formattedCreatedDate = invoice && invoice.created_at
    ? moment(invoice.created_at).format("DD-MM-YYYY HH:mm:ss")
    : "";

  const renderImage = () => {
    if (!businessprofile || !businessprofile.logo) {
      return <Skeleton.Image active />;
    }
    return (
      <img
        src={businessprofile.logo}
        alt="Business Logo"
        style={{
          width: "60%",
          right: "0",
        }}
      />
    );
  };

  const renderitems = () => {
    if (!items || items.length === 0) {
      return (
        <tr>
          <td colSpan="5" style={{ textAlign: "center" }}>No items found</td>
        </tr>
      );
    }

    return items.map((item, index) => {
      serialcount.current = index + 1;
      return (
        <tr key={item.id}>
          <td>{index + 1}</td>
          <td>
            {item.Product && item.Product[0] && item.Product[0].Deatils && item.Product[0].Deatils[0] ? (
              <>
                {item.Product[0].Deatils[0].product_code} -- {item.Product[0].Deatils[0].title} -- {item.Product[0].Attribute_details}
              </>
            ) : (
              item.Details || "N/A"
            )}
          </td>
          <td>{formatter.format((item.price - item.spec_discount))}</td>
          {/* <td>{formatter.format(item.spec_discount)}</td> */}
          <td style={{ textAlign: "center" }}>{item.quantity}</td>
          <td style={{ textAlign: "center" }}>
            {formatter.format((item.price - item.spec_discount) * item.quantity)}
          </td>
        </tr>
      );
    });
  };

  if (!invoice) {
    return null;
  }

  return (
    <>
      <Button
        type="default"
        icon={<PrinterOutlined />}
        onClick={showDrawer}
        style={{ marginLeft: 8 }}
      >
        Print Invoice
      </Button>

      <Drawer
        width="40%"
        onClose={onClose}
        visible={visible}
        placement="right"
        bodyStyle={{ margin: 0 }}
        title="Invoice Preview"
      >
        <ReactToPrint
          trigger={() => (
            <Button type="primary" icon={<PrinterOutlined />} block style={{ marginBottom: 16 }}>
              Print this out!
            </Button>
          )}
          content={() => componentRef.current}
        />

        {/* Hidden Print Content */}
        <div style={{ display: "none" }}>
          <div ref={componentRef} style={{ padding: "10px" }}>
            <Row
              className="invoice_print_fontSize"
              style={{
                marginTop: "2px",
                paddingBottom: "2px",
              }}
            >
              <Col span={24} style={{ textAlign: "center" }}>
                <Row>
                  <Col span={8} style={{ textAlign: "left" }}>
                    <div style={{
                      transformOrigin: "right",
                      width: "fit-content",
                      height: "fit-content",
                      position: "absolute",
                      top: "100%",
                      right: "30px",
                      transform: "scale(1) translateY(-50%)"
                    }}>
                      {renderImage()}
                    </div>
                  </Col>
                  <Col span={8} style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <div style={{ fontWeight: "800", fontSize: "44px", letterSpacing: "5px", fontFamily: '"Times New Roman", Times, serif', }}>
                      CONTRAST
                    </div>
                  </Col>
                  <Col span={8}></Col>
                </Row>


                <div
                  className="d-div"
                  dangerouslySetInnerHTML={{
                    __html: businessprofile && businessprofile.address ? businessprofile.address : "",
                  }}
                />
                <div
                  className="d-div"
                  dangerouslySetInnerHTML={{ __html: businessprofile && businessprofile.social_link ? businessprofile.social_link : "" }}
                />
                <div
                  className="d-div"
                  dangerouslySetInnerHTML={{ __html: businessprofile && businessprofile.website_link ? businessprofile.website_link : "" }}
                />

                {branch && branch.contact && (
                  <>Showroom: <>{branch.contact}</></>
                )}

                <div style={{ borderWidth: 2, borderStyle: 'solid', borderColor: '#303338', marginBottom: "5px" }}></div>
              </Col>

              <Col span={24} style={{ marginTop: "10px" }}>
                INVOICE NO. {invoice.invoice_number && <b>{invoice.invoice_number}</b>}
                <br />

                {branch && branch.contact && (
                  <>
                    CALL/CONTACT: <b>{branch.contact}</b>
                    <br />
                  </>
                )}

                {invoice.issue_date && (
                  <>
                    ISSUE DATE: {formattedCreatedDate}
                    <br />
                  </>
                )}

                {invoice.delivery_date && (
                  <>
                    DELIVERY DATE: {invoice.delivery_date}
                    <br />
                  </>
                )}

                {invoice.program_date && (
                  <>PROGRAM DATE: {invoice.program_date}</>
                )}
              </Col>

              {invoice.contact && invoice.Contact && invoice.Contact[0] && (
                <Row>
                  <Col span={24} style={{ textAlign: "left" }}>
                    <Row>
                      <Col span={24}>
                        {invoice.Contact[0].name && (
                          <>CUSTOMER NAME: {invoice.Contact[0].name}</>
                        )}
                      </Col>
                      <Col span={24}>
                        {invoice.Contact[0].phone && (
                          <>CUSTOMER PHONE: {invoice.Contact[0].phone}</>
                        )}
                      </Col>
                      <Col span={24}>
                        {invoice.Contact[0].address && (
                          <>CUSTOMER ADDRESS: {invoice.Contact[0].address}</>
                        )}
                      </Col>
                    </Row>
                  </Col>

                  <Col span={24} style={{ textAlign: "right" }}>
                    <Row>
                      <Col span={24}>
                        {invoice.shipping_name && (
                          <>SHIPPING NAME: {invoice.shipping_name}</>
                        )}
                      </Col>
                      <Col span={24}>
                        {invoice.shipping_phone && (
                          <>SHIPPING PHONE: {invoice.shipping_phone}</>
                        )}
                      </Col>
                      <Col span={24}>
                        {invoice.shipping_address && (
                          <>SHIPPING ADDRESS: {invoice.shipping_address}</>
                        )}
                      </Col>
                    </Row>
                  </Col>
                </Row>
              )}
            </Row>

            <br />

            <Row>
              <Col span={24}>
                <table className="product_table invoice_print_fontSize">
                  <tbody>
                    <tr style={{ fontWeight: "600", border: "2px" }}>
                      <td>SL</td>
                      <td>Details</td>
                      <td>MRP</td>
                      {/* <td>Discount</td> */}
                      <td>Qty</td>
                      <td>Total</td>
                    </tr>
                    {renderitems()}
                  </tbody>
                </table>

                <Row>
                  <Col
                    className="invoice_print_fontSize"
                    span={8}
                    style={{ textAlign: "left", marginTop: "20px" }}
                  >
                    {invoice.remarks && (
                      <Row>
                        <div
                          className="d-div-invoice"
                          style={{
                            fontWeight: '800',
                            fontSize: '20px',
                            color: 'red',
                          }}
                          dangerouslySetInnerHTML={{ __html: invoice.remarks }}
                        />
                      </Row>
                    )}
                  </Col>

                  <Col
                    span={14}
                    className="invoice_print_fontSize"
                    style={{
                      textAlign: "right",
                      marginTop: "20px",
                    }}
                  >
                    {invoice.delivery_charge > 0 && (
                      <Row>
                        <Col span={18} style={{ margin: "auto" }}>
                          DELIVERY CHARGE(+)
                        </Col>
                        <Col span={5} offset={1}>
                          <span className="order_span_bill">
                            {formatter.format(invoice.delivery_charge)}
                          </span>
                        </Col>
                      </Row>
                    )}

                    {invoice.discount > 0 && (
                      <Row>
                        <Col span={18} style={{ margin: "auto" }}>
                          DISCOUNT(-)
                        </Col>
                        <Col span={5} offset={1}>
                          <span className="order_span_bill">
                            {formatter.format(invoice.discount)}
                          </span>
                        </Col>
                      </Row>
                    )}
                    {/* {invoice.spec_item_discount > 0 ? (
                      <>
                        <Row>
                          <Col span={18} style={{ margin: "auto" }}>
                            PRODUCT DISCOUNT(-)
                          </Col>
                          <Col span={5} offset={1}>
                            <span className="order_span_bill">
                              {formatter.format(invoice.spec_item_discount)}
                            </span>
                          </Col>
                        </Row>
                      </>
                    ) : (
                      ""
                    )} */}

                    <Row>
                      <Col span={18} style={{ margin: "auto" }}>
                        TOTAL AMOUNT
                      </Col>
                      <Col span={5} offset={1}>
                        <span className="order_span_bill">
                          {formatter.format(invoice.bill)}
                        </span>
                      </Col>
                    </Row>

                    <Row>
                      <Col span={18} style={{ margin: "auto" }}>
                        TOTAL PAYMENT
                      </Col>
                      <Col span={5} offset={1}>
                        <span className="order_span_bill">
                          {formatter.format(invoice.payment)}
                        </span>
                      </Col>
                    </Row>

                    <Row>
                      <Col span={18} style={{ margin: "auto" }}>
                        BALANCE DUE
                      </Col>
                      <Col span={5} offset={1}>
                        <span className="order_span_bill">
                          {formatter.format(invoice.due)}
                        </span>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Col>
            </Row>

            <br />

            <h4 style={{ fontWeight: '800', fontSize: '14px' }}>
              <u>TERMS & CONDITIONS:</u>
            </h4>
            <ul>
              <li style={{ fontWeight: '600', fontSize: "14px" }}>
                1. Product Can Be Exchanged Within 3 Days Intact Condition
              </li>
              <li style={{ fontWeight: '600', fontSize: "14px" }}>
                2. Under Any Circumstances Can Any Amount Be Refunded
              </li>
              <li style={{ fontWeight: '600', fontSize: "14px" }}>
                3. Invoice must be brought for exchanging product
              </li>
            </ul>

            <br />

            <Row style={{ margin: "auto" }}>
              <Col span={16}>
                <Barcode
                  value={invoice.invoice_number}
                  width={3}
                  height={40}
                  format="CODE128"
                />
              </Col>
              <Col span={2}></Col>
              <Col span={2}></Col>
            </Row>

            <div style={{ borderWidth: 2, borderStyle: 'solid', borderColor: '#303338', marginBottom: "5px" }}></div>

            <div style={{ fontWeight: '700', fontSize: "14px", marginTop: "10px" }}>
              Powered by: THE ICT HUB
            </div>
            <div style={{ fontWeight: '700', fontSize: "14px", marginBottom: "10px" }}>
              Visit: https://theicthub.com
            </div>
          </div>
        </div>

        {/* Visible Preview Content */}
        <div>
          <div style={{ padding: "10px" }}>
            <Row style={{ marginTop: "10px", paddingBottom: "5px" }}>
              <Col span={24} style={{ textAlign: "center" }}>
                {renderImage()}
              </Col>

              <Col span={24}>
                {/* MUSHAK 6.3<br /> */}
                INVOICE NO. {invoice.invoice_number && <b>{invoice.invoice_number}</b>}
                <br />

                {branch && branch.contact && (
                  <>
                    CALL/CONTACT: <b>{branch.contact}</b>
                    <br />
                  </>
                )}

                {invoice.issue_date && (
                  <>
                    ISSUE DATE: {invoice.issue_date}
                    <br />
                  </>
                )}

                {invoice.delivery_date && (
                  <>
                    DELIVERY DATE: {invoice.delivery_date}
                    <br />
                  </>
                )}

                {invoice.program_date && (
                  <>PROGRAM DATE: {invoice.program_date}</>
                )}
              </Col>

              {invoice.contact && invoice.Contact && invoice.Contact[0] && (
                <Row>
                  <Col span={24} style={{ textAlign: "left" }}>
                    <Row>
                      <Col span={24}>
                        {invoice.Contact[0].name && (
                          <>CUSTOMER NAME: {invoice.Contact[0].name}</>
                        )}
                      </Col>
                      <Col span={24}>
                        {invoice.Contact[0].phone && (
                          <>CUSTOMER PHONE: {invoice.Contact[0].phone}</>
                        )}
                      </Col>
                      <Col span={24}>
                        {invoice.Contact[0].address && (
                          <>CUSTOMER ADDRESS: {invoice.Contact[0].address}</>
                        )}
                      </Col>
                    </Row>
                  </Col>

                  <Col span={24} style={{ textAlign: "right" }}>
                    <Row>
                      <Col span={24}>
                        {invoice.shipping_name && (
                          <>SHIPPING NAME: {invoice.shipping_name}</>
                        )}
                      </Col>
                      <Col span={24}>
                        {invoice.shipping_phone && (
                          <>SHIPPING PHONE: {invoice.shipping_phone}</>
                        )}
                      </Col>
                      <Col span={24}>
                        {invoice.shipping_address && (
                          <>SHIPPING ADDRESS: {invoice.shipping_address}</>
                        )}
                      </Col>
                    </Row>
                  </Col>
                </Row>
              )}
            </Row>

            <br />

            <Row>
              <Col span={24}>
                <table className="product_table">
                  <tbody>
                    <tr style={{ fontWeight: "500" }}>
                      <td>SL</td>
                      <td>PRODUCT DETAILS</td>
                      <td>RATE</td>
                      {/* <td>DISCOUNT</td> */}
                      <td>QTY</td>
                      <td>AMOUNT</td>
                    </tr>
                    {renderitems()}
                  </tbody>
                </table>

                <Row>
                  <Col
                    className="invoice_print_fontSize"
                    span={8}
                    style={{ textAlign: "left", marginTop: "20px" }}
                  >
                    {invoice.remarks && (
                      <Row>
                        <div
                          className="d-div-invoice"
                          style={{
                            fontWeight: '800',
                            fontSize: '20px',
                            color: 'red',
                          }}
                          dangerouslySetInnerHTML={{ __html: invoice.remarks }}
                        />
                      </Row>
                    )}
                  </Col>

                  <Col
                    span={16}
                    style={{
                      textAlign: "right",
                      marginTop: "5px",
                    }}
                  >
                    {invoice.delivery_charge > 0 && (
                      <Row>
                        <Col span={18} style={{ margin: "auto" }}>
                          DELIVERY CHARGE(+)
                        </Col>
                        <Col span={5} offset={1}>
                          <span className="order_span_bill">
                            {formatter.format(invoice.delivery_charge)}
                          </span>
                        </Col>
                      </Row>
                    )}

                    {invoice.discount > 0 && (
                      <Row>
                        <Col span={18} style={{ margin: "auto" }}>
                          DISCOUNT(-)
                        </Col>
                        <Col span={5} offset={1}>
                          <span className="order_span_bill">
                            {formatter.format(invoice.discount)}
                          </span>
                        </Col>
                      </Row>
                    )}

                    {/* {invoice.spec_item_discount > 0 ? (
                      <>
                        <Row>
                          <Col span={18} style={{ margin: "auto" }}>
                            PRODUCT DISCOUNT(-)
                          </Col>
                          <Col span={5} offset={1}>
                            <span className="order_span_bill">
                              {formatter.format(invoice.spec_item_discount)}
                            </span>
                          </Col>
                        </Row>
                      </>
                    ) : (
                      ""
                    )} */}

                    <Row>
                      <Col span={18} style={{ margin: "auto" }}>
                        TOTAL AMOUNT
                      </Col>
                      <Col span={5} offset={1}>
                        <span className="order_span_bill">
                          {formatter.format(invoice.bill)}
                        </span>
                      </Col>
                    </Row>

                    <Row>
                      <Col span={18} style={{ margin: "auto" }}>
                        TOTAL PAYMENT
                      </Col>
                      <Col span={5} offset={1}>
                        <span className="order_span_bill">
                          {formatter.format(invoice.payment)}
                        </span>
                      </Col>
                    </Row>

                    <Row>
                      <Col span={18} style={{ margin: "auto" }}>
                        BALANCE DUE
                      </Col>
                      <Col span={5} offset={1}>
                        <span className="order_span_bill">
                          {formatter.format(invoice.due)}
                        </span>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Col>
            </Row>
          </div>
        </div>
      </Drawer>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    businessprofile: state.settings.businessprofile,
  };
};

export default connect(mapStateToProps, {
  getBusinessProfile,
})(EcommerceOrderPrint);